import React, { Component } from 'react';
import { langFromSlug, buildPath, isValidLangSlug, normalizeLocalizedPath, routeFromPath } from '../utils/route_utils';
import { setCookie } from '../utils/cookie_utils';

/**
 * HOC wrapper that extracts language from URL params and provides
 * lang + navigation helpers to wrapped page components.
 *
 * Usage: <LangRoute component={MainPage} />
 * The wrapped component receives: lang, updateLang, navigate
 */
class LangRoute extends Component {
  constructor(props) {
    super(props);

    const currentPath = window.location.pathname;
    const normalizedPath = normalizeLocalizedPath(currentPath);
    const effectivePath = normalizedPath || currentPath;

    // Extract lang from the normalized URL when possible
    const pathParts = effectivePath.split('/').filter(Boolean);
    const langSlug = pathParts[0] || 'zh-tw';
    const lang = isValidLangSlug(langSlug) ? langFromSlug(langSlug) : 'zh';

    this.state = {
      lang,
      redirectPath: normalizedPath !== null && normalizedPath !== currentPath ? normalizedPath : null
    };
    this.updateLang = this.updateLang.bind(this);
    this.navigate = this.navigate.bind(this);
  }

  componentDidMount() {
    if (this.state.redirectPath) {
      window.location.replace(this.state.redirectPath + window.location.search + window.location.hash);
      return;
    }

    setCookie('lang', this.state.lang, 30);
  }

  updateLang(newLang) {
    setCookie('lang', newLang, 30);
    this.setState({ lang: newLang });

    // Navigate to same page with new language prefix
    const route = routeFromPath(window.location.pathname);
    window.location.href = buildPath(newLang, route);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  render() {
    if (this.state.redirectPath) {
      return null;
    }

    const PageComponent = this.props.component;
    return (
      <PageComponent
        lang={this.state.lang}
        updateLang={this.updateLang}
        navigate={this.navigate}
      />
    );
  }
}

export default LangRoute;
